import React from "react";
import { Stack } from "@mui/material";
import NumberedPagination from "../LoadMore/NumberedPagination";

export default function ListingTableFooter({
    pagination,
    onPageChange,
    onPageSizeChange,
    rightActions = null, // optional JSX (download button, etc.)
    mt = 2,
    mb = 5,
}) {
    if (!pagination) return null;

    return (
        <Stack direction="row" spacing={2} justifyContent="center" alignItems="center" mt={mt} mb={mb}>
            <NumberedPagination
                totalCount={pagination.totalPages}
                totalRecordCount={pagination.totalRecords}
                defaultSelectedPage={(pagination.pageNumber ?? 0) + 1}
                changeCall={onPageChange}
                rowSizeChangeCall={onPageSizeChange}
                rowSize={pagination.pageSize}
            />
            {rightActions}
        </Stack>
    );
}
